import React from 'react';
import { SectionTitle } from '@benzinga/core-ui';
import { PostCard, PostCardLayout, PostCardSize } from '@benzinga/news';
import { WordpressPost } from '@benzinga/content-manager';

import styled from '@benzinga/themetron';

export interface MoneyPostsProps {
  layout?: PostCardLayout;
  link?: string;
  posts: WordpressPost[];
  size?: PostCardSize;
  title?: string;
  hidePublishDate?: boolean;
}

export const MoneyPosts: React.FC<MoneyPostsProps> = ({
  hidePublishDate = false,
  layout = 'feed',
  link,
  posts,
  size = 'compact',
  title,
}) => {
  if (!Array.isArray(posts) || posts.length < 1) {
    return <div />;
  }

  const dataAction = title ? `${title} Money Post Click` : 'Money Post Click';

  return (
    <MoneyPostWrapper className="money-post-wrapper">
      {title && (
        <div className="posts-header">
          <SectionTitle level={2} rightSlot={link && <span className="see-more">See more</span>} url={link}>
            {title}
          </SectionTitle>
        </div>
      )}
      <div className={`posts-container ${layout}`}>
        {posts.map(post => {
          return (
            <PostCard
              created={post.published_at}
              dataAction={dataAction}
              description={post.description}
              hidePublishDate={hidePublishDate}
              id={post.id}
              image={post.image}
              key={post.id}
              layout={layout}
              size={size}
              title={post.title}
              url={post.url}
            />
          );
        })}
      </div>
    </MoneyPostWrapper>
  );
};

export const MoneyPostWrapper = styled.div`
  &.money-post-wrapper {
    display: block;
    margin: 16px 0;
    .posts-header {
      align-items: center;
      display: inline-flex;
      justify-content: space-between;
      width: 100%;
      border-bottom: solid 1px ${({ theme }) => theme.colorPalette.neutral500};
      margin: 16px 0;
      padding: 4px 0;
    }
    .post-card {
      margin-bottom: 1rem;
    }
    .posts-container.default {
      display: grid;
      gap: 12px;
      grid-template-columns: repeat(4, minmax(0, 1fr));
      grid-template-rows: repeat(1, minmax(0, 1fr));
      @media (max-width: 768px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        grid-template-rows: repeat(2, minmax(0, 1fr));
      }
    }
  }
`;
